module.exports = __webpack_public_path__ + "static/media/science3.de571906.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/img/science3.jpg
// module id = 584
// module chunks = 0